import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import Login from '../auth/Login';
import SessionExpiredModal from '../auth/SessionExpiredModal';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { authenticated, loading, sessionExpired } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <h1>Loading...</h1>
      </div>
    );
  }

  if (!authenticated) {
    return <Login />;
  }

  return (
    <>
      {children}
      {sessionExpired ? <SessionExpiredModal /> : null}
    </>
  );
};

export default ProtectedRoute;
